var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M114 19C61.5315 19 19 61.5315 19 114C19 166.468 61.5315 209 114 209C166.468 209 209 166.468 209 114C209 61.5315 166.468 19 114 19ZM114 190L133 171L142.5 161.5V142.5H123.5V133L114 123.5H85.5V152L104.5 171V189.344C67.07 184.642 38 152.684 38 114L47.5 123.5H66.5V104.5H85.5L114 76V57H95L85.5 47.5V43.5955C103.77 36.1454 124.23 36.1454 142.5 43.5955V57L133 66.5V85.5L142.5 95L172.235 65.265C179.469 73.9188 184.681 84.0771 187.492 95H171L152 114V133L161.5 142.5H180.5L183.217 145.217C171.275 171.579 144.771 190 114 190Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeGrey);
export default __webpack_public_path__ + "static/media/globeGrey.9cdc251d20715cc43f4f00adc18b5d81.svg";
export { ForwardRef as ReactComponent };